import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const comunicacionInternaImporterSelectors = importerSelectors(
  'comunicacionInterna.importer',
);

export default comunicacionInternaImporterSelectors;
